import AreaTypeContainer from "./AreaTypeContainer";

export default AreaTypeContainer;
